<template>
    <div class="sync-progress">
        <i :class="getIconClass" :style="getIconStyle"></i>
    </div>
</template>

<script>
export default {
    props: {
        state: {
            type: String,
            required: true,
        },
        animationSpeed: {
            type: Number,
            required: true,
            default: 1,
        },
    },
    computed: {
        getIconClass() {
            switch (this.state) {
                case 'running':
                    return [
                        'fas',
                        'fa-sync',
                        'fa-spin',
                        'rotate-animation',
                        'icon-running',
                    ];
                case 'done':
                    return ['fas', 'fa-check-circle', 'icon-done'];
                case 'fail':
                    return ['fas', 'fa-times-circle', 'icon-fail'];
                default:
                    return '';
            }
        },
        getIconStyle() {
            if (this.state === 'running') {
                return {
                    animationDuration: `${this.animationSpeed}s`,
                };
            }
            return {};
        },
    },
};
</script>

<style scoped>
.rotate-animation {
    animation-name: rotate;
    animation-timing-function: linear;
    animation-iteration-count: infinite;
}

@keyframes rotate {
    from {
        transform: rotate(0deg);
    }
    to {
        transform: rotate(360deg);
    }
}

.icon-running {
    color: grey;
}

.icon-done {
    color: green;
}

.icon-fail {
    color: red;
}
</style>
